import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {isEmpty} from 'lodash'
import classNames from 'classnames'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Table from 'components/Table'
import {accessIdSelector, appIdSelector, isTourEnabledSelector} from 'modules/Login/selectors/user'
import {expiratedSelector} from './selectors/expirated'
import {fetchExpirated} from './actions'
import {MTableToolbar} from 'material-table'
import {Avatar, Button, Card, CardContent, CardHeader, Grid, useTheme} from '@material-ui/core'
import Modal from './Modal'
import StudentList from './components/studentListNegotiation'
import PaymentOptions, {PAYMENT_OPTIONS} from './Modal/components/paymentOptions'
import useStyle from './style'
import {apiResetAction} from 'utils/API/actions/status'
import { Info } from "@material-ui/icons";
import {EXPIRATED_FINANCIALS, REGISTRATION_EXPIRED} from './constants'
import Loading from 'components/loading'
import CustomCellHighlight from 'components/CustomCellHighlight'
import {FormattedMessage, injectIntl} from 'react-intl'
import {isTourEnabledPaymentSelector} from './selectors/payment'
import csatList from "../../../utils/csatList";
import useCsat from "../../../hooks/use-csat";
import Csat from "../../../components/Csat/Csat";
import Alert from '@material-ui/lab/Alert';
import {getFinancialAgreementPending} from "./services/financial";
import {fetchSelectedExpirated, setRegistrationExpiredSelected} from 'modules/Negotiation/Finance/actions';
import {
  financialAgreementPendingDataSelector,
  hasLoadedFinancialAgreementPendingSelector,
  isLoadingFinancialAgreementPendingSelector
} from './selectors/financialAgreementPending';
import {useRecoilValue, useSetRecoilState} from "recoil";
import {selectedCreditCardState} from "../../../recoil/atoms/selectedCreditCardState";
import * as _blackListService from "../../../service/blacklist-service";
import blockedResourcesSystem from "../../../utils/blockedResourcesSystem";
import {blockedResourcesEntitiesValues} from "../../../utils/blockedResourcesEntities";
import {AssignmentTurnedInRounded} from '@material-ui/icons';
import {selectedMatriculaState} from "../../../recoil/atoms/selectedMatriculaState";

export const STYLE_CELLS = {
  paddingRight: 20,
  paddingLeft: 0
}

const smColumns = [
  { title: 'Mês/Ano', field: 'yearMonthFormatted', cellStyle: STYLE_CELLS },
  { title: 'Vencimento', field: 'expirationdateFormatted', cellStyle: STYLE_CELLS, customSort: (param1, param2) => Date.parse(param1.expirationdate) - Date.parse(param2.expirationdate) },
]

const otherColumns = [
  { title: 'Fatura', field: 'invoice', cellStyle: STYLE_CELLS },
  // { title: 'Valor Corrigido', field: 'correctvalueFormatted', cellStyle: STYLE_CELLS, customSort: (param1, param2) => parseFloat(param1.correctvalue) - parseFloat(param2.correctvalue) }
]

const otherMediumColumns = [
  { title: 'Aluno', field: 'studentnameFormatted', cellStyle: STYLE_CELLS },
]

const lastDefaultColumn = [
  { title: 'Valor no Vencimento', field: 'documentvalueFormatted', cellStyle: STYLE_CELLS, customSort: (param1, param2) => parseFloat(param1.documentvalue) - parseFloat(param2.documentvalue) }
]

export default injectIntl(({ intl: { messages } }) => {
  const classes = useStyle()
  const tableRef = useRef()
  const dispatch = useDispatch()
  const theme = useTheme()
  const financialAgreementPending = useSelector(financialAgreementPendingDataSelector)
  const hasLoadedFinancialAgreement = useSelector(hasLoadedFinancialAgreementPendingSelector)
  const isLoadingFinancialAgreement = useSelector(isLoadingFinancialAgreementPendingSelector)

  const appid = useSelector(appIdSelector)
  const accessId = useSelector(accessIdSelector)
  const isTourOpen = useSelector(isTourEnabledSelector)
  const isEnableTourModal = useSelector(isTourEnabledPaymentSelector)

  const { data, dataSelected, loading, error } = useSelector(expiratedSelector)

  const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'))
  const isMedium = useMediaQuery(theme => theme.breakpoints.down('md'))

  const [valueOption, setValueOption] = React.useState(PAYMENT_OPTIONS.CARD)
  const [isFirst, setIsFirst] = useState(true)
  const [openModalBilletPay, setOpenModalBilletPay] = useState(false)
  const setSelectedCard = useSetRecoilState(selectedCreditCardState);
  const title = messages['finance-negotiation-table-title']
  const isBillet = valueOption === PAYMENT_OPTIONS.BILLET
  const [viewLock, setViewLock] = useState({})
  const [isLoadingBlockedResources, setIsLoadingBlockedResources] = useState(true)
  const [blockedResources, setBlockedResources] = useState([])
  const selectedMatricula = useRecoilValue(selectedMatriculaState)
  
  useEffect(() => {
    const unidade = selectedMatricula?.unidade_Id;
    if (unidade && blockedResources && blockedResources.length) {
      const locksFiltered = blockedResources.filter(r => r?.unidadeId === unidade && r.type === blockedResourcesEntitiesValues.Unidade)
      if (locksFiltered) {
        const verifylock = (
          {
            lockName,
            action,
            setLock,
            defaultMessage,
            selectedYear
          }
        ) => {
          const lockFound = locksFiltered.find(x => x.action === action)
          if (lockFound) {
            setLock({
              [lockName]: true,
              [`${lockName}Message`]: lockFound?.mensagemBloqueio && lockFound?.mensagemBloqueio !== ''
                ? lockFound?.mensagemBloqueio
                : defaultMessage
            })
          } else {
            setLock({})
          }
        }

        verifylock({
          lockName: 'view',
          setLock: setViewLock,
          action: 'AcordoPortal/Unidade',
          defaultMessage: 'Bloqueado para esta unidade',
        })

        verifylock({
          lockName: 'boleto',
          setLock: setViewLock,
          action: 'BoletoAcordoPortal/Unidade',
          defaultMessage: 'Bloqueado para esta unidade',
        })
      }
    }
  }, [blockedResources, selectedMatricula]);

  useEffect(() => {
    if (isTourOpen) {
      return
    }
    if (!blockedResources || !blockedResources.length) {
      _blackListService.GetBySistemaId(blockedResourcesSystem.SMO).then((response) => {
        if (response && response.length) {
          setBlockedResources(response)
        }
        setIsLoadingBlockedResources(false)
      }).catch(() => {
        setIsLoadingBlockedResources(false)
      })
    }
  }, [isTourOpen, blockedResources]);

  const {
    addAnsweredCsat,
    isCsatVisible,
    handleShowCsat
  } = useCsat();

  useEffect(() => {
    if (isTourOpen) {
      return
    }
    if (isFirst) {
      setIsFirst(false)
      dispatch(apiResetAction(EXPIRATED_FINANCIALS))
      dispatch(apiResetAction(REGISTRATION_EXPIRED))
    }
    if (dataSelected && dataSelected.length && !hasLoadedFinancialAgreement && !isLoadingFinancialAgreement) {
        dispatch(getFinancialAgreementPending(appid, dataSelected[0].dataareaid, dataSelected[0].accountresponsible, dataSelected[0].registrationid))
    }
    if (valueOption && tableRef.current) {
      tableRef.current.onAllSelected(true)
    }
  }, [appid, accessId, dispatch, isFirst, valueOption, data, dataSelected, isTourOpen, financialAgreementPending])

  useEffect(() => {
    if (isTourOpen && !isEmpty(data)) {
      return
    }
    dispatch(fetchExpirated({ accessId }))
    setValueOption('')
  }, [accessId, dispatch, appid, isTourOpen])

  const openModal = () => {
    setOpenModalBilletPay(true)
  }

  const changeOptions = (value) => {
    setValueOption(value)
    //tableRef.current.onSearchChange('')
  }

  const actions = (props) => {
    return (
      <div>
        <MTableToolbar {...props} />
        <Grid 
          container
          justifyContent='center'
        >
        <Card
          style={{
            width: isSmall ? 'auto' : '100%',
            display: 'flex',
            flexDirection: isSmall ? 'column' : 'row',
            justifyContent: 'space-between',
            margin: '10px',
            boxShadow: 'none'
          }}
        >
          <CardHeader
            title={ "Regularize agora a sua situação financeira!" }
            subheader={ isSmall ? "É só selecionar o método de Pagamento 👇" : "É só selecionar o método de Pagamento 👉" }
            avatar={
              <Avatar 
                style={{ backgroundColor: "#bdbdbd47" }}
                aria-label="success icon"
               >
                <AssignmentTurnedInRounded
                  color='primary'
                />
              </Avatar>
            }
          />
            <CardContent
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: theme.breakpoints.down(500) ? 'column' : 'row',
                gap: theme.breakpoints.down(500) ? '10px' : ''
              }}
            >
              <Button
                data-tut='tur-do-negotiation'
                style={{
                  padding: '10px',
                }}
                variant='contained'
                color='primary'
                id='btn-pay-billet'
                onClick={() => {
                  changeOptions(PAYMENT_OPTIONS.CARD)
                  openModal()
                }}
              >
                Cartão de Crédito
              </Button>
              {!viewLock?.boleto && (
                <Button
                  data-tut='tur-do-negotiation'
                  style={{
                    padding: '10px',
                    marginLeft: theme.breakpoints.down(500) ? '0' : '10px',
                  }}
                  variant='contained'
                  color='primary'
                  id='btn-pay-billet'
                  onClick={() => {
                    changeOptions(PAYMENT_OPTIONS.BILLET)
                    openModal()
                  }}
                >
                  Boleto Bancário
                </Button>
              )}
            </CardContent>
        </Card>
        </Grid>
      </div >
    )
  }

  const columns = () => {
    return [
      ...smColumns,
      ...(isSmall ? [] : otherColumns),
      ...(isMedium ? [] : otherMediumColumns),
      ...lastDefaultColumn
    ]
  }

  if (loading) {
    return (
      <Loading />
    )
  }

  const handleCloseCsat = () => {
    const body = document.querySelector('body')
    if (body) body.classList.remove('csatBlockScroll')
    addAnsweredCsat(csatList.acordo)
  }

  const selectStudent = (student) => {
    dispatch(getFinancialAgreementPending(appid, dataSelected[0].dataareaid, dataSelected[0].accountresponsible, student.registrationId))
    dispatch(fetchSelectedExpirated(student.studentName, student.unityId))
    dispatch(setRegistrationExpiredSelected(student))
  }

  if (viewLock?.view) {
    return (
      <Alert severity="warning">
        {viewLock?.viewMessage}
      </Alert>
    )
  }

  if (!isEmpty(error) || !dataSelected && !isLoadingBlockedResources) {
    return (
      <Alert severity="error">
        {error.message}
      </Alert>
    )
  }

  return (
    <div>
      <Modal
        open={openModalBilletPay || isEnableTourModal}
        onClose={() => {
          setSelectedCard(null)
          setOpenModalBilletPay(false)
          handleShowCsat(csatList.acordo)
        }}
        isBillet={isBillet}
        data={tableRef.current && tableRef.current.state.originalData}
        parcelasBlock={viewLock?.view}
      />

      <Csat
        show={isCsatVisible(csatList.acordo)}
        scoreTitle="O quanto você ficou satisfeito com: Acordo?"
        onSubmit={handleCloseCsat}
        onClosed={handleCloseCsat}
      />

      <Card>
        <CardHeader title={messages['finance-negotiation-title-registration']} >
        </CardHeader>
        <CardContent >
          <StudentList
            selectRegistration={selectStudent}
          />
        </CardContent>
      </Card>
      <br />
      {financialAgreementPending?.processStatus ?
      <Card
        elevation={1}
        sx={{
          boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px'
        }}
      >
        <CardHeader
          title={"Já existe uma solicitação de acordo em andamento!"}
          subheader={financialAgreementPending?.message}
          avatar={
            <Avatar sx={{ bgcolor: "#bdbdbd38" }} aria-label="success icon">
              <Info color='primary'/>
            </Avatar>
          }
        />
      </Card>
      :
      <div data-tut='tur-table-negotiation' >
        <Table
          isLoading={loading || isLoadingFinancialAgreement || isLoadingBlockedResources}
          tableRef={tableRef}
          components={{
            Toolbar: actions,
            Cell: (props) => <CustomCellHighlight {...props} tableref={tableRef} />
          }}
          options={{
            showTextRowsSelected: false,
            selectionProps: (rowData) => {
              return {
                disabled: true,
                'data-tut': 'tur-home-check-pay',
                color: 'primary',
                id: 'pay-select-all-' + rowData.tableData.id
              }
            },
            search: true,
            showSelectAllCheckbox: false,
            selection: false,
            paging: false,
            sorting: true,
            headerStyle: {
              fontSize: 15,
              paddingRight: 1
            }
          }}
          columns={columns()}
          data={dataSelected}
          title={title}
        />
      </div>
    }
    </div>)
})